// @ts-nocheck
import { WishListModel } from "@insite/client-framework/Types/ApiModels";

const getWishlistShowFavorites = (wishlist: WishListModel[] | undefined) => {
    return Boolean(wishlist?.find(x => !x.isAutogenerated));
};

export default getWishlistShowFavorites;
